import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// URL状態に依存せず、常に SL 導線クエリ(?entry=sl)を付与する
export const buildSuiteLoungeEntryPath = (path: string) => `${path}?entry=sl`;

export const useSuiteLoungeFlow = () => {
  const [searchParams] = useSearchParams();
  const isSuiteLoungeFlow = searchParams.get('entry') === 'sl';
  const withEntry = useCallback(
    (path: string) =>
      isSuiteLoungeFlow ? buildSuiteLoungeEntryPath(path) : path,
    [isSuiteLoungeFlow],
  );

  return { isSuiteLoungeFlow, withEntry };
};
